'use client';
import { LegalShell, LegalSection, EntityCard, useLang, type Lang } from '@/components/LegalShell';

const C: Record<Lang, { title: string; sub: string; updated: string; s: { h: string; p: string[] }[]; entityNote: string }> = {
  uk: {
    title: 'Політика конфіденційності', updated: '18.07.2026',
    sub: 'Як ми збираємо, використовуємо й захищаємо ваші персональні дані на gamessales.vip.',
    entityNote: 'Оператор обробки платежів:',
    s: [
      { h: '1. Які дані ми збираємо', p: ['Email, ім’я профілю, історія замовлень, дані, необхідні для доставки цифрового товару, а також технічні дані (IP, тип пристрою) для безпеки й аналітики.'] },
      { h: '2. Мета обробки', p: ['Дані використовуються для оформлення й доставки замовлень, підтримки, запобігання шахрайству та покращення сервісу. Ми не продаємо ваші дані третім особам.'] },
      { h: '3. Платіжні дані', p: ['Дані банківських карток обробляються виключно на боці ліцензованих платіжних операторів. Ми не зберігаємо повні реквізити карток.'] },
      { h: '4. Зберігання й захист', p: ['Дані зберігаються на захищених серверах із шифруванням доступу. Термін зберігання — не довше, ніж потрібно для виконання зобов’язань і вимог законодавства.'] },
      { h: '5. Ваші права', p: ['Ви можете запросити перегляд, виправлення або видалення своїх даних, звернувшись до підтримки на сторінці «Контакти».'] },
      { h: '6. Cookies', p: ['Ми використовуємо cookies для роботи кошика, авторизації, мовних/валютних налаштувань та аналітики.'] },
    ],
  },
  ru: {
    title: 'Политика конфиденциальности', updated: '18.07.2026',
    sub: 'Как мы собираем, используем и защищаем ваши персональные данные на gamessales.vip.',
    entityNote: 'Оператор обработки платежей:',
    s: [
      { h: '1. Какие данные мы собираем', p: ['Email, имя профиля, история заказов, данные, необходимые для доставки цифрового товара, а также технические данные (IP, тип устройства) для безопасности и аналитики.'] },
      { h: '2. Цель обработки', p: ['Данные используются для оформления и доставки заказов, поддержки, предотвращения мошенничества и улучшения сервиса. Мы не продаём ваши данные третьим лицам.'] },
      { h: '3. Платёжные данные', p: ['Данные банковских карт обрабатываются исключительно на стороне лицензированных платёжных операторов. Мы не храним полные реквизиты карт.'] },
      { h: '4. Хранение и защита', p: ['Данные хранятся на защищённых серверах с шифрованием доступа. Срок хранения — не дольше, чем необходимо для выполнения обязательств и требований законодательства.'] },
      { h: '5. Ваши права', p: ['Вы можете запросить просмотр, исправление или удаление своих данных, обратившись в поддержку на странице «Контакты».'] },
      { h: '6. Cookies', p: ['Мы используем cookies для работы корзины, авторизации, языковых/валютных настроек и аналитики.'] },
    ],
  },
  en: {
    title: 'Privacy Policy', updated: '2026-07-18',
    sub: 'How we collect, use and protect your personal data on gamessales.vip.',
    entityNote: 'Payment processing operator:',
    s: [
      { h: '1. Data we collect', p: ['Email, profile name, order history, data required to deliver digital goods, and technical data (IP, device type) for security and analytics.'] },
      { h: '2. Purpose', p: ['Data is used to place and deliver orders, provide support, prevent fraud and improve the service. We do not sell your data to third parties.'] },
      { h: '3. Payment data', p: ['Card data is processed solely by licensed payment operators. We do not store full card details.'] },
      { h: '4. Storage & security', p: ['Data is stored on secure servers with encrypted access, no longer than required to fulfil obligations and legal requirements.'] },
      { h: '5. Your rights', p: ['You may request to view, correct or delete your data by contacting support on the “Contacts” page.'] },
      { h: '6. Cookies', p: ['We use cookies for the cart, authentication, language/currency settings and analytics.'] },
    ],
  },
};

export default function PrivacyPage() {
  const lang = useLang();
  const c = C[lang];
  return (
    <LegalShell title={c.title} subtitle={c.sub} updated={c.updated}>
      {c.s.map(sec => (
        <LegalSection key={sec.h} heading={sec.h}>
          {sec.p.map((t, i) => <p key={i} style={{ margin: i ? '10px 0 0' : 0 }}>{t}</p>)}
        </LegalSection>
      ))}
      <LegalSection heading={c.entityNote}><EntityCard /></LegalSection>
    </LegalShell>
  );
}
